module.exports = {
  contactEditReturnPath: '',
}
